import { Component } from '@angular/core';
import { AppMainComponent } from './app.main.component';
import { User, UserService } from './core';
import { Router } from '@angular/router';
import { AdministracionService } from './administracion/administracion.service';
import { UsuarioModel } from './modelo/usuario.model';
import { environment } from 'src/environments/environment';
import { UIService } from './core/services/ui.service';
import {AvatarModule} from 'primeng/avatar';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import {BadgeModule} from 'primeng/badge';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {

    //Variables de configuración/mensajes
    appConfig = environment.settings;
    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    photo: any;

    ui: UIService;
    
    alertarActualizacion:boolean = false;
    serverVersionNumber:number = 0;

    constructor(
        public app: AppMainComponent,
        private router: Router,
        private userService: UserService,
        private administracionService: AdministracionService,
        private uiService: UIService,
    ) {
        this.ui = uiService;
        this.loadAppVersion();
    }

    ngOnInit(): void {
        
        // Mostrar el menú lateral desplegado por defecto
//        this.app.menuActive = true;

        this.userService.currentUser.subscribe(
            (userData) => {
                this.currentUser = userData;
                let imagen = this.ui.sanitize(this.currentUser.image);
                this.photo = imagen ? imagen : '/assets/layout/icons/user.png';
                }
        );
    }
    
    async loadAppVersion(){
        const version = await this.uiService.getPlatformVersion();
        this.serverVersionNumber = version.serverVersion;
        this.alertarActualizacion = version.actualizar;
    }
}
